import React, {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import { useHistory } from "react-router-dom";

import {client} from "../../../App";
import {UserRoleEnum} from "../../../helpers/enums";
import {hideLoading, showLoading} from "../../../reducers/app";
import {setCurrentSelectedContract, setCurrentSelectedClientCode, setBillsToShowForAdminMunicipal, setShowedAdminMunicipalModal, setAdminMunicipalBillsToShow} from "../../../reducers/contracts";
import {
  DOWNLOAD_BILLS,
  MUNICIPAL_BILL_DOWNLOAD,
  CONDOMINIUM_ADMIN_INVOICES_DOWNLOAD,
  CONTRACT_DETAIL
} from "../../../helpers/queries";
import {
  isObject,
  SwitchUser,
  payBills,
  checkConractStatus,
  convertTime,
  convertTimeWithFormat,
  TranslatedText,
} from "../../../helpers/helpers";

import {ContractDetailReq} from "../../../models/Contract";
import ActionPanel from "../../common/ActionPanel/ActionPanel";
import Hero from "../../common/Hero/Hero";
import FiltersBox from "../../common/FiltersBox/FiltersBox";
import DataTable from "../../common/DataTable/DataTable";
import SuccessModal from "../../forms/ContractAddForm/Modal";
import NoResult from "../../common/NoResult/NoResult";
import PaymentReceiptModal from "../../common/PaymentReceiptModal/PaymentReceiptModal";
import Modal from "../../common/Modal/Modal";
import "./BillsPage.scss";
import { Tooltip } from "../../common/Tooltip/Tooltip";

const BillsPage = (props) => {
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const {match, computedMatch, isFromDashboardLink} = props;
  const {params} = match || computedMatch;
  const {trackIdPayment, contractId} = params;
  const history = useHistory();

  const auth = useSelector((state) => state.auth);
  const userProfile = SwitchUser(auth);
  const role = userProfile.role;
  const isCondominiumAdmin = role === UserRoleEnum.CONDOMINIUM_ADMIN;
  const isMunicipalUser = role === UserRoleEnum.MUNICIPAL_USER;
  const isCondominiumAdminOrMunicipalUser = role === UserRoleEnum.CONDOMINIUM_ADMIN || role === UserRoleEnum.MUNICIPAL_USER;

  const listContracts = useSelector((state) => state.contracts.list);
  const current = useSelector((state) => state.contracts.current);
  const currentContract = current ? current.id : null;

  const currentSelectedContract = useSelector((state) => state.contracts.currentContractSelected);
  const currentSelectedContractId = currentSelectedContract ? currentSelectedContract.id : null;
  const currentSelectedClientCode = useSelector((state) => state.contracts.currentClientCodeSelected);
  const optionChooseContract = {id: '0'};
  const optionChooseClientCode = {clientCode: '0'};

  const [selectedRows, setSelectedRows] = useState([]);
  const [genericError, setGenericError] = useState(null);
  const [infoModal, setInfoModal] = useState({active: false});
  const [downloaded, setDownloaded] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = useSelector((state) => state.contracts.totalPages);
  // const [flowFinished, setFlowFinished] = useState(false);
  // const [paidBills, setPaidBills] = useState([]);
  // const [responseStatus, setStatus] = useState(false);

  const [filters, setFilters] = useState({});
  const allBills = useSelector((state) => state.contracts.bills) || null;

  const bills = useSelector((state) => state.contracts.bills) || [];
  const adminMunicipalBillsToShow = useSelector((state) => state.contracts.adminMunicipalBillsToShow) || [];
  const [filteredContracts, setFilteredContracts] = useState(bills);
  const [filterMode, setFilterMode] = useState(false);
  const [selectedStartDate, setStartDate] = useState({});
  const [selectedEndDate, setEndDate] = useState({});
  const from = convertTimeWithFormat(new Date() - (86400000)*731, "YYYY-MM-DD");
  const to = convertTimeWithFormat(new Date(), "YYYY-MM-DD");
  const [filtersToSend, setFiltersToSend] = useState({from, to});
  const [filterConfiguration, setFilterConfiguration] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [showPopupBank, setShowPopupBank] = useState(false);
  const [showPopupOnlineBill, setShowPopupOnlineBill] = useState(false);
  const serviceOnlineBill = useSelector((state) => state.contracts.serviceOnlineBill);
  const serviceBankDomiciliation = useSelector((state) => state.contracts.serviceBankDomiciliation);
  const showedAdminMunicipalModal = useSelector((state) => state.contracts.showedAdminMunicipalModal);

  const filterConfig = {
    fields: [
      {
        label: t("bills.filters.contract"),
        name: "contratto",
        type: "contractDropDown",
        leftIcon: "lens",
        columnSize: "6",
      },
      {
        label: t("bills.headers.invoiceNumber"),
        name: "search_key",
        type: "input",
        placeholder: t("common.codiceFattura"),
        billNumber: true,
        columnSize: "6",
      },
      {
        name: "documentType",
        label: t("bills.headers.invoiceDocumentType"),
        type: "simpleSelect",
        initialValue: "ALL",
        placeholder: t("common.documentType"),
        options: [
          {
            label: <TranslatedText i18nKey={"common.documentType.all"}/>,
            value: "ALL",
          },
          {
            label: <TranslatedText i18nKey={"invoces_docuementType_NAC"}/>,
            value: "NAC",
          },
          {
            label: <TranslatedText i18nKey={"invoces_docuementType_BOL"}/>,
            value: "BOL",
          },
        ],
        billNumber: true,
        columnSize: "6",
      },
      {
        label: t("calendar.header.from"),
        name: "dateStart",
        placeholder: t("bills.datepicker.placeholder"),
        type: "date",
        columnSize: "3",
      },
      {
        label: t("calendar.header.to"),
        name: "dateEnd",
        placeholder: t("bills.datepicker.placeholder"),
        type: "date",
        columnSize: "3",
      },
    ],
    validations: [],
    configuration: {
      hasReset: true,
    },
  };

  const filterConfigAdminMunicipal = {
     fields: [
       {
         label: t("bills.filters.client.code"),
         name: "codice_cliente",
         type: "clientCodeDropdown",
         leftIcon: "lens",
         columnSize: "6",
       },
       {
         name: "check",
         type: "emptyField",
         columnSize: "6",
       },
       {
         label: t("bills.filters.contract"),
         name: "contratto",
         type: "contractDropDownWithEmptyOption",
         leftIcon: "lens",
         columnSize: "6",
       },
       {
         label: t("bills.headers.invoiceNumber"),
         name: "search_key",
         type: "input",
         placeholder: t("common.codiceFattura"),
         billNumber: true,
         columnSize: "6",
       },
       {
         name: "documentType",
         label: t("bills.headers.invoiceDocumentType"),
         type: "simpleSelect",
         initialValue: "ALL",
         placeholder: t("common.documentType"),
         options: [
           {
             label: <TranslatedText i18nKey={"common.documentType.all"}/>,
             value: "ALL",
           },
           {
             label: <TranslatedText i18nKey={"invoces_docuementType_NAC"}/>,
             value: "NAC",
           },
           {
             label: <TranslatedText i18nKey={"invoces_docuementType_BOL"}/>,
             value: "BOL",
           },
         ],
         billNumber: true,
         columnSize: "6",
       },
       {
         label: t("calendar.header.from"),
         name: "dateStart",
         placeholder: t("bills.datepicker.placeholder"),
         type: "date",
         columnSize: "3",
       },
       {
         label: t("calendar.header.to"),
         name: "dateEnd",
         placeholder: t("bills.datepicker.placeholder"),
         type: "date",
         columnSize: "3",
       },
     ],
     validations: [],
     configuration: {
       hasReset: true,
     },
  };

  if(isFromDashboardLink) {
    history.replace('/bills');
  }

  useEffect(() => {
    if(isCondominiumAdminOrMunicipalUser && !isFromDashboardLink) {
      dispatch(setAdminMunicipalBillsToShow([]));
      dispatch(setCurrentSelectedContract(optionChooseContract));
      dispatch(setCurrentSelectedClientCode(optionChooseClientCode));
      setStartDate(new Date(new Date() - (86400000)*731));
      setEndDate(new Date());
      dispatch(setBillsToShowForAdminMunicipal({from,to}, 1));
    }
    if(isCondominiumAdmin && isFromDashboardLink) {
      dispatch(setAdminMunicipalBillsToShow([]));
      dispatch(setCurrentSelectedContract(current));
      dispatch(setCurrentSelectedClientCode(optionChooseClientCode));
      var contractId = currentContract;
      checkModalShow(contractId);
      dispatch(setBillsToShowForAdminMunicipal({contractId}, 1));
      setFiltersToSend({contractId});
    }
  }, []);

  useEffect(()=>{
    if(serviceOnlineBill != null && serviceBankDomiciliation != null && !isCondominiumAdminOrMunicipalUser){
      dispatch(showLoading());
      setShowPopupBank(!serviceBankDomiciliation.enabled);
      setShowPopupOnlineBill(!serviceOnlineBill.enabled);
      setShowPopup(!(serviceOnlineBill.enabled && serviceBankDomiciliation.enabled));
      dispatch(hideLoading());
    }
  }, [serviceOnlineBill, serviceBankDomiciliation])

  useEffect(() => {
    if(isCondominiumAdminOrMunicipalUser) {
      setFilterConfiguration({
        fields: [
          {
            label: t("bills.filters.client.code"),
            name: "codice_cliente",
            type: "clientCodeDropdown",
            leftIcon: "lens",
            columnSize: "6",
          },
          {
            name: "check",
            type: "emptyField",
            columnSize: "6",
          },
          {
            label: t("bills.filters.contract"),
            name: "contratto",
            type: "contractDropDownWithEmptyOption",
            leftIcon: "lens",
            columnSize: "6",
          },
          {
            label: t("bills.headers.invoiceNumber"),
            name: "search_key",
            type: "input",
            placeholder: t("common.codiceFattura"),
            billNumber: true,
            columnSize: "6",
          },
          {
            name: "documentType",
            label: t("bills.headers.invoiceDocumentType"),
            type: "select",
            initialValue: "ALL",
            placeholder: t("common.documentType"),
            options: [
              {
                label: <TranslatedText i18nKey={"common.documentType.all"}/>,
                value: "ALL",
              },
              {
                label: <TranslatedText i18nKey={"invoces_docuementType_NAC"}/>,
                value: "NAC",
              },
              {
                label: <TranslatedText i18nKey={"invoces_docuementType_BOL"}/>,
                value: "BOL",
              },
            ],
            billNumber: true,
            columnSize: "6",
          },
          {
            label: t("calendar.header.from"),
            name: "dateStart",
            placeholder: t("bills.datepicker.placeholder"),
            type: "date",
            columnSize: "3",
            twoYearsAgo: !isFromDashboardLink
          },
          {
            label: t("calendar.header.to"),
            name: "dateEnd",
            placeholder: t("bills.datepicker.placeholder"),
            type: "date",
            columnSize: "3",
            today: !isFromDashboardLink
          },

        ],
        validations: [],
        configuration: {
          hasReset: true,
        },
      })
    } else {
      setFilterConfiguration({
        fields: [
          {
            label: t("bills.filters.contract"),
            name: "contratto",
            type: "contractDropDown",
            leftIcon: "lens",
            columnSize: "6",
          },
          {
            label: t("bills.headers.invoiceNumber"),
            name: "search_key",
            type: "input",
            placeholder: t("common.codiceFattura"),
            billNumber: true,
            columnSize: "6",
          },
          {
            name: "documentType",
            label: t("bills.headers.invoiceDocumentType"),
            type: "select",
            initialValue: "ALL",
            placeholder: t("common.documentType"),
            options: [
              {
                label: <TranslatedText i18nKey={"common.documentType.all"}/>,
                value: "ALL",
              },
              {
                label: <TranslatedText i18nKey={"invoces_docuementType_NAC"}/>,
                value: "NAC",
              },
              {
                label: <TranslatedText i18nKey={"invoces_docuementType_BOL"}/>,
                value: "BOL",
              },
            ],
            billNumber: true,
            columnSize: "6",
          },
          {
            label: t("calendar.header.from"),
            name: "dateStart",
            placeholder: t("bills.datepicker.placeholder"),
            type: "date",
            columnSize: "3",
          },
          {
            label: t("calendar.header.to"),
            name: "dateEnd",
            placeholder: t("bills.datepicker.placeholder"),
            type: "date",
            columnSize: "3",
          },
        ],
        validations: [],
        configuration: {
          hasReset: true,
        },
      })
    }
    // eslint-disable-next-line
  }, [filters, t])
  // eslint-disable-next-line

  const [width, setDimensions] = React.useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setDimensions(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [allBills]);

  const addFiltersToSend = (e) => {
    let filtersObject= {};
    if(currentSelectedClientCode.clientCode !== '0') {
      filtersObject.integraClientCode = currentSelectedClientCode.clientCode;
    }
    if(currentSelectedContractId !== '0') {
      filtersObject.contractId = currentSelectedContractId;
    }
    if(e.search_key !== "") {
      filtersObject.invoiceNumber = e.search_key;
    }
    if(e.documentType !== "ALL") {
      filtersObject.documentType = e.documentType;
    }
    if(e.dateStart && e.dateStart !== "" && e.dateEnd && e.dateEnd !== "") {
      filtersObject.from = convertTimeWithFormat(e.dateStart, "YYYY-MM-DD");
      filtersObject.to = convertTimeWithFormat(e.dateEnd, "YYYY-MM-DD");
    }
    setFiltersToSend(filtersObject);
    return filtersObject;
  }

  const onFiltersChanged = (e) => {
    if (e.dateStart || e.dateEnd || e.search_key || e.documentType) {
      const filterData = {
        contratto: e.contratto,
        startDate: e.dateStart,
        endDate: e.dateEnd,
        search_key: e.search_key,
        documentType: e.documentType,
      };
      setStartDate(e.dateStart);
      setEndDate(e.dateEnd);
      if(!isCondominiumAdminOrMunicipalUser) {
        setFilters(filterData);
      };
      setFilterMode(true);
    } else {
      setFilterMode(false);
    }
  };

  const onFiltersReset = (e) => {
    if(isCondominiumAdminOrMunicipalUser) {
      setFilterConfiguration(filterConfigAdminMunicipal);
    } else {
      setFilterConfiguration(filterConfig);
    }
    if(currentSelectedContract) {
      dispatch(setCurrentSelectedContract(optionChooseContract));
      dispatch(setCurrentSelectedClientCode(optionChooseClientCode));
    }
  }

  const setBackendFilteredAdminMunicipalBills = (filters, whichPage) => {
    const filtersObj = addFiltersToSend(filters);
    if (filters.dateStart && filters.dateEnd || currentSelectedContractId !== '0' || filters.search_key !== "") {
      if (731 >= daysDiffer(filters.dateStart, filters.dateEnd) || currentSelectedContractId !== '0' || filters.search_key !== "") {
        if(!showedAdminMunicipalModal && currentSelectedContract && currentSelectedContractId !== '0') {
          checkModalShow(currentSelectedContractId);
        }
        if(currentSelectedContract) {
          dispatch(setBillsToShowForAdminMunicipal(filtersObj, whichPage));
          setCurrentPage(whichPage);
        } else {
          return;
        }
      } else {
        setInfoModal({active: true});
        return;
      }
    } else {
      setInfoModal({active: true});
      return;
    }
  }

  const getSelectedIds = () => {
    const selectedIds = [];
    Object.keys(selectedRows).forEach((key) => {
      if (selectedIds.length <= 3) {
        selectedIds.push(bills[key]);
      }
    });
    return selectedIds;
  };

  const convertToPrice = (value) => `€${Number(value).toFixed(2)}`;

  const orderColumns = ["test1", "test2", "test3"];

  const handleRowSelect = (rowsIds, rowsData) => {
    const previousRow = JSON.stringify(selectedRows);
    const addedRow = JSON.stringify(rowsData);
    if (previousRow !== addedRow) {
      setSelectedRows(rowsData);
      setGenericError(null);
    }
  };

  const handleMunicilapDownload = async () => {
    if (selectedStartDate && selectedEndDate || currentSelectedContractId !== '0' || filtersToSend.invoiceNumber) {
      if (731 >= daysDiffer(selectedStartDate, selectedEndDate) || currentSelectedContractId !== '0' || filtersToSend.invoiceNumber) {
        dispatch(showLoading());
        setGenericError(null);
        try {
          const downloadMunicipalBill = await client().query({
            query: MUNICIPAL_BILL_DOWNLOAD,
            variables: {
              req: {
                ...filtersToSend
              },
            },
            fetchPolicy: "network-only",
          });
          if (
            downloadMunicipalBill.data &&
            downloadMunicipalBill.data.municipalInvoicesDownload &&
            downloadMunicipalBill.data.municipalInvoicesDownload.path
          ) {
            window.open(
              downloadMunicipalBill.data.municipalInvoicesDownload.path,
              "_blank"
            );
            dispatch(hideLoading());
          }
        } catch (error) {
          console.log(error);
          setGenericError(t("common.serverError"));
          dispatch(hideLoading());
        }
      } else {
        setInfoModal({active: true});
      }
    } else {
      setInfoModal({active: true});
    }
  };

  const checkModalShow = async (id) => {
    dispatch(showLoading());
    try {
      const response = await client().query({
        query: CONTRACT_DETAIL,
        variables: {...ContractDetailReq(id)},
        fetchPolicy: "network-only",
      });
      if (response.data) {
        let serviceOnlineBill = response.data.contractDetail.serviceOnlineBill;
        let serviceBankDomiciliation = response.data.contractDetail.serviceBankDomiciliation;
        if(serviceOnlineBill && serviceBankDomiciliation && isCondominiumAdminOrMunicipalUser){
          dispatch(showLoading());
          setShowPopupBank(!serviceBankDomiciliation.enabled);
          setShowPopupOnlineBill(!serviceOnlineBill.enabled);
          setShowPopup(!(serviceOnlineBill.enabled && serviceBankDomiciliation.enabled));
          dispatch(hideLoading());
          dispatch(setShowedAdminMunicipalModal(true));
        }
        dispatch(hideLoading());
      }
    } catch (error) {
      console.log(error);
      dispatch(hideLoading());
    }
  };

  const handleCondominiumAdminInvoicesDownload = async () => {
    if (selectedStartDate && selectedEndDate || currentSelectedContractId !== '0' || filtersToSend.invoiceNumber) {
      if (731 >= daysDiffer(selectedStartDate, selectedEndDate) || currentSelectedContractId !== '0' || filtersToSend.invoiceNumber) {
        dispatch(showLoading());
        setGenericError(null);

        try {
          const downloadAdminBill = await client().query({
            query: CONDOMINIUM_ADMIN_INVOICES_DOWNLOAD,
            variables: {
              req: {
                ...filtersToSend
              },
            },
            fetchPolicy: "network-only",
          });
          if (
            downloadAdminBill.data &&
            downloadAdminBill.data.condominiumAdminInvoicesDownload &&
            downloadAdminBill.data.condominiumAdminInvoicesDownload.path
          ) {
            window.open(
              downloadAdminBill.data.condominiumAdminInvoicesDownload.path,
              "_blank"
            );
            dispatch(hideLoading());
          }
        } catch (error) {
          console.log(error);
          setGenericError(t("common.serverError"));
          dispatch(hideLoading());
        }
      } else {
        setInfoModal({active: true});
      }
    } else {
      setInfoModal({active: true});
    }
  };

  const daysDiffer = (startDay, endDay) => {
    const oneDay = 24 * 60 * 60 * 1000;
    const start = new Date(startDay);
    const end = new Date(endDay);

    return Math.round(Math.abs((start - end) / oneDay));
  };

  const handleDownload = async (contractId, invoiceNumber) => {
    if (selectedRows.length > 3) {
      setGenericError(t("bills.download.maxLength"));
      return;
    }
    genericError && setGenericError(null);
    dispatch(showLoading());

    try {
      const downlodType = selectedRows.length > 1 ? "ZIP" : "PDF";
      const downloadBills = await client().query({
        query: DOWNLOAD_BILLS,
        variables: {
          req: {
            contractId: isCondominiumAdminOrMunicipalUser ? contractId : currentContract,
            invoiceNumbers: isCondominiumAdminOrMunicipalUser ? [invoiceNumber] : selectedRows.map(
              (selectedRow) => selectedRow.invoiceNumber
            ),
            downloadType: isCondominiumAdminOrMunicipalUser ? "PDF" : downlodType,
          },
        },
        fetchPolicy: "network-only",
      });
      if (
        downloadBills.data &&
        downloadBills.data.invoicesDownload &&
        downloadBills.data.invoicesDownload.path
      ) {
        window.open(downloadBills.data.invoicesDownload.path, "_blank");
        dispatch(hideLoading());
        setSelectedRows([]);
        setDownloaded(true);
      }
    } catch (error) {
      setGenericError(t("bills.errorDownloadingBill"));
      dispatch(hideLoading());
    }
  };

  const nextPageCondominiumAdminOrMunicipal = () => {
    dispatch(setBillsToShowForAdminMunicipal(filtersToSend, currentPage + 1));
    setCurrentPage(currentPage + 1);
  }

  const prevPageCondominiumAdminOrMunicipal = () => {
    dispatch(setBillsToShowForAdminMunicipal(filtersToSend, currentPage - 1));
    setCurrentPage(currentPage - 1);
  }

  const handlePayBill = (bill) => {
    const billCode = bill.id;
    const billsToPaid = {
      codIdContratto: isCondominiumAdmin ? bill.contractId : currentContract,
      codIdBolletta: billCode,
      channel: "WEB",
    };
    payBills(billsToPaid, dispatch, setGenericError, [bill]);
  };

  const retrieveContractState = (contractId) => {
    const contractCheck = listContracts.filter((contract) => {
      if(contract.id === contractId) {
        return contract;
      }
    });
    if(contractCheck[0]) {
      return contractCheck[0].state;
    }
  }

  const columnsAdminOrMunicipal = React.useMemo(
    () => [
      {
    Header: () => null, 
    id: "iconDownload",
    Cell: ({ row }) => {
   return (
    <button
      className="iconInvoiceDownload"
      onClick={() => handleDownload(row.original.contractId, row.original.invoiceNumber)}
      aria-label={t("download.document.label")}
    >
      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M15.53 15.0329C15.6662 15.0329 15.7786 15.0819 15.8672 15.18C15.9557 15.2781 16 15.3903 16 15.5164C16 15.6566 15.9557 15.7722 15.8672 15.8633C15.7786 15.9544 15.6662 16 15.53 16H0.469987C0.333759 16 0.221371 15.9544 0.132822 15.8633C0.0442742 15.7722 0 15.6566 0 15.5164C0 15.3903 0.0442742 15.2781 0.132822 15.18C0.221371 15.0819 0.333759 15.0329 0.469987 15.0329H15.53ZM8.01022 0C8.13282 0 8.24181 0.0490583 8.33716 0.147175C8.43252 0.245291 8.4802 0.357424 8.4802 0.483574V11.9212L12.7305 7.54796C12.8123 7.44985 12.9178 7.40079 13.0473 7.40079C13.1767 7.40079 13.2891 7.44985 13.3844 7.54796C13.4798 7.63206 13.5275 7.74069 13.5275 7.87385C13.5275 8.00701 13.4798 8.12265 13.3844 8.22076L8.33716 13.435C8.2963 13.463 8.25883 13.4875 8.22478 13.5085C8.19072 13.5296 8.15326 13.5471 8.11239 13.5611H7.96935H7.88761C7.84674 13.5471 7.80928 13.5296 7.77522 13.5085C7.74117 13.4875 7.7037 13.463 7.66284 13.435L2.61558 8.22076C2.52022 8.12265 2.47254 8.00701 2.47254 7.87385C2.47254 7.74069 2.52022 7.63206 2.61558 7.54796C2.71094 7.44985 2.82333 7.40079 2.95275 7.40079C3.08216 7.40079 3.19455 7.44985 3.28991 7.54796L7.5198 11.9212V0.483574C7.5198 0.357424 7.56748 0.245291 7.66284 0.147175C7.75819 0.0490583 7.87399 0 8.01022 0Z" fill="black"/>
      </svg>
          </button>
        );
    }
      },
      {
        Header: t("contract.visualization.contract.code"),
        accessor: "contractCodeIntegra",
        id: 9,       
        Cell: ({ row }) => {
          return (
            <>
              {row.original.contractCodeIntegra && row.original.contractCodeIntegra !== "" ? (
                <div style={{ display: "inline-flex", alignItems: "center", gap: "3px" }}>
                  <span className="contract-number">{row.original.contractCodeIntegra}</span>
                  <Tooltip
                    triggerContent={
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.028 14.2308C9.249 14.2308 9.4355 14.1544 9.5875 14.0017C9.7395 13.8491 9.8155 13.6623 9.8155 13.4413C9.8155 13.2201 9.73917 13.0336 9.5865 12.8818C9.43383 12.7298 9.24692 12.6538 9.02575 12.6538C8.80475 12.6538 8.61825 12.7301 8.46625 12.8828C8.31442 13.0354 8.2385 13.2223 8.2385 13.4435C8.2385 13.6645 8.31483 13.851 8.4675 14.003C8.62017 14.1548 8.807 14.2308 9.028 14.2308ZM9.00325 18C7.75875 18 6.58867 17.7638 5.493 17.2915C4.3975 16.8192 3.4445 16.1782 2.634 15.3685C1.8235 14.5588 1.18192 13.6067 0.70925 12.512C0.236417 11.4175 0 10.2479 0 9.00325C0 7.75875 0.236167 6.58867 0.7085 5.493C1.18083 4.3975 1.82183 3.4445 2.6315 2.634C3.44117 1.8235 4.39333 1.18192 5.488 0.70925C6.5825 0.236417 7.75208 0 8.99675 0C10.2413 0 11.4113 0.236167 12.507 0.708501C13.6025 1.18083 14.5555 1.82183 15.366 2.6315C16.1765 3.44117 16.8181 4.39333 17.2908 5.488C17.7636 6.5825 18 7.75208 18 8.99675C18 10.2413 17.7638 11.4113 17.2915 12.507C16.8192 13.6025 16.1782 14.5555 15.3685 15.366C14.5588 16.1765 13.6067 16.8181 12.512 17.2908C11.4175 17.7636 10.2479 18 9.00325 18ZM9 17C11.2333 17 13.125 16.225 14.675 14.675C16.225 13.125 17 11.2333 17 9C17 6.76667 16.225 4.875 14.675 3.325C13.125 1.775 11.2333 1 9 1C6.76667 1 4.875 1.775 3.325 3.325C1.775 4.875 1 6.76667 1 9C1 11.2333 1.775 13.125 3.325 14.675C4.875 16.225 6.76667 17 9 17ZM9.062 4.7385C9.56817 4.7385 10.0042 4.89567 10.3702 5.21C10.7362 5.52417 10.9193 5.917 10.9193 6.3885C10.9193 6.75517 10.8163 7.08658 10.6105 7.38275C10.4048 7.67892 10.1667 7.952 9.89625 8.202C9.55358 8.51267 9.25183 8.85442 8.991 9.22725C8.73033 9.60008 8.58075 10.0108 8.54225 10.4595C8.52942 10.5903 8.57017 10.6997 8.6645 10.7875C8.75867 10.8753 8.86858 10.9192 8.99425 10.9192C9.12892 10.9192 9.24208 10.8743 9.33375 10.7845C9.42542 10.6948 9.48342 10.5891 9.50775 10.4672C9.57442 10.1301 9.70833 9.83042 9.9095 9.56825C10.1108 9.30608 10.3317 9.05783 10.572 8.8235C10.9177 8.47967 11.2247 8.10492 11.4932 7.69925C11.7619 7.29375 11.8962 6.84142 11.8962 6.34225C11.8962 5.60775 11.6177 5.00167 11.0605 4.524C10.5035 4.0465 9.85 3.80775 9.1 3.80775C8.54367 3.80775 8.026 3.93783 7.547 4.198C7.06817 4.45833 6.68517 4.81858 6.398 5.27875C6.33267 5.38908 6.31175 5.50317 6.33525 5.621C6.35875 5.73883 6.42225 5.82833 6.52575 5.8895C6.65725 5.95933 6.79033 5.97567 6.925 5.9385C7.05967 5.90133 7.17825 5.82375 7.28075 5.70575C7.50258 5.43008 7.76383 5.2 8.0645 5.0155C8.36517 4.83083 8.69767 4.7385 9.062 4.7385Z" fill="#0768A9"/>
                  </svg>
                    }
                    tooltipContent={
                      <>
                        {row.original.clientCodeIntegra + " - " + row.original.businessName}<br />
                        {row.original.puf.street} {row.original.puf.streetNumber} {row.original.puf.city}<br />
                        {row.original.puf.province} {row.original.puf.postalCode}
                      </>
                    }
                    ariaLabel="Mostra dettagli contratto"
                  />
                </div>
              ) : (
                <p>-</p>
              )}
            </>
          );
        }
      },
      {
        Header: t("bills.headers.invoiceNumber"),
        accessor: "invoiceNumber",
        id: 1,
      },
      {
        Header: t("bills.headers.issueDate"),
        accessor: "issueDate",
        id: 2,
        Cell: ({row}) =>
          row.original.issueDate ? (
            (row.original.issueDate).replaceAll("/","-")
          ) : (
            <p>-</p>
          ),
      },
      {
        Header: t("bills.headers.expirationDate"),
        accessor: "expirationDate",
        id: 3,
        Cell: ({row}) =>
          row.original.expirationDate ? (
            (row.original.expirationDate).replaceAll("/","-")
          ) : (
            <p>-</p>
          ),
      },
      {
        Header: t("bills.headers.invoiceDocumentType"),
        accessor: "documentType",
        id: 8,
        Cell: ({row}) => (
          <p>
            {row.original.documentType
              ? row.original.documentType === "BOL"
                ? t("invoces_docuementType_BOL")
                : row.original.documentType === "NAC"
                  ? t("invoces_docuementType_NAC")
                  : "-"
              : "-"}
          </p>
        ),
      },
      {
        Header: t("bills.headers.status"),
        accessor: "status",
        id: 4,
        Cell: ({row}) => {
          if (row.original.documentType === "NAC") {
            return <p>{t("bills.status.accreditata")}</p>;
          } else {
            if (!row.original.isPaid) {
              if (checkConractStatus(retrieveContractState(row.original.contractId))) {
                if (role !== UserRoleEnum.MUNICIPAL_USER) {
                  return (
                  <a
                    href="#"
                    role="button"
                    className="underline link-style"
                    aria-label={t("bills.pay.anchor.pay")}
                    onClick={(e) => {
                      e.preventDefault(); // evita navigazione
                      handlePayBill(row.original);
                    }}
                  >
                    {t("bills.pay.label")}
                  </a>
                  );
                } else {
                  return <p>{t("bills.pay.label")}</p>;
                }
              } else {
                return <p>{row.original.isPaid ? t("bills.status.paid") : t("bills.pay.label")}</p>;
              }
            } else {
              return <p>{t("bills.status.paid")}</p>;
            }
          }
        },
      },
      {
        Header: t("bills.headers.amount"),
        accessor: "amount",
        id: 5,
        Cell: ({row}) => {
          return convertToPrice(row.original.amount);
        },
      },
      {
        Header: t("bills.headers.residualAmount"),
        accessor: "residualAmount",
        id: 6,
        Cell: ({row}) => {
          if (row.original.residualAmount) {
            if (checkConractStatus(retrieveContractState(row.original.contractId))) {
              return <p>{convertToPrice(row.original.residualAmount)}</p>;
            } else {
              return <p>{"-"}</p>;
            }
          } else {
            return <p>{"-"}</p>;
          }
        },
      },
      {
        Header: t("bills.headers.deferredPayment"),
        accessor: "deferredPayment",
        id: 7,
        Cell: ({row}) => {
          return row.original.deferredPayment === "N"
            ? t("bills.utils.nd")
            : t("bills.utils.yes");
        },
      },
    ],
    // eslint-disable-next-line
    [t, filters]
  );

  const columns = React.useMemo(
    () => [
      {
        // Make an expander cell
        Header: ({getToggleAllRowsSelectedProps}) => {
          const p = getToggleAllRowsSelectedProps();
          delete p.indeterminate;
          delete p.title;
          if (role !== UserRoleEnum.MUNICIPAL_USER) {
            return (
              <>
                <div className="form-check abc-checkbox">
                  <input
                    {...p}
                    className="form-check-input"
                    id="checkbox1"
                    type="checkbox"
                    aria-label={t("header.checkbox.label")}
                  />
                  <label
                    aria-hidden="true"
                    className=" form-check-label"
                    htmlFor="checkbox1"
                  />
                </div>
              </>
            );
          } else {
            return null;
          }
        },
        //selectedRows.length <= 2
        id: "checkBox", // It needs an ID
        accessor: "expander",
        Cell: ({row, getToggleAllRowsSelectedProps}) => {
          const p = row.getToggleRowSelectedProps();
          delete p.indeterminate;
          delete p.title;
          // if (role !== UserRoleEnum.MUNICIPAL_USER) {
          return (
            <>
              {checkConractStatus(current.state) ? (
                <div className="form-check abc-checkbox">
                  <input
                    {...p}
                    type="checkbox"
                    name={`checkbox-${row.id}`}
                    id={`checkbox-${row.id}`}
                    aria-describedby="bills-table-error-message"
                    aria-label={t("checkbox.label.invoiceNumber") + " " + row.original.invoiceNumber}
                    onChange={(e) => {
                      if (selectedRows.length >= 3) {
                        e.target.checked = false;
                        setGenericError(t("bills.download.maxLength"));
                      }
                      p.onChange(e);
                    }}
                  />

                  <label
                    className="form-check-label"
                    htmlFor={`checkbox-${row.id}`}
                  ></label>
                </div>
              ) : (
                <div className="form-check abc-checkbox">
                  <input
                    {...p}
                    type="checkbox"
                    name={`checkbox-${row.id}`}
                    id={`checkbox-${row.id}`}
                    aria-label={`Seleziona riga mettere dinamico`}
                     aria-describedby="bills-table-error-message"
                    onChange={(e) => {
                      if (selectedRows.length >= 3) {
                        e.target.checked = false;
                        setGenericError(t("bills.download.maxLength"));
                      }
                      p.onChange(e);
                    }}
                  />

                  <label
                    className="form-check-label"
                    htmlFor={`checkbox-${row.id}`}
                  ></label>
                </div>
              )}
            </>
          );
        },
      },
      {
        Header: t("bills.headers.invoiceNumber"),
        accessor: "invoiceNumber",
        id: 1,
      },
      {
        Header: t("bills.headers.issueDate"),
        accessor: "issueDate",
        id: 2,
        Cell: ({row}) => convertTime(row.original.issueDate),
      },
      {
        Header: t("bills.headers.expirationDate"),
        accessor: "expirationDate",
        id: 3,
        Cell: ({row}) =>
          row.original.expirationDate ? (
            convertTime(row.original.expirationDate)
          ) : (
            <p>-</p>
          ),
      },
      {
        Header: t("bills.headers.invoiceDocumentType"),
        accessor: "documentType",
        id: 8,
        Cell: ({row}) => (
          <p>
            {row.original.documentType
              ? row.original.documentType === "BOL"
                ? t("invoces_docuementType_BOL")
                : row.original.documentType === "NAC"
                  ? t("invoces_docuementType_NAC")
                  : "-"
              : "-"}
          </p>
        ),
      },
      {
        Header: t("bills.headers.status"),
        accessor: "status",
        id: 4,
        Cell: ({row}) => {
          if (row.original.documentType === "NAC") {
            return <p>{t("bills.status.accreditata")}</p>;
          } else {
            if (!row.original.isPaid) {
              if (checkConractStatus(current.state)) {
                if (role !== UserRoleEnum.MUNICIPAL_USER) {
                  return (
                  <a
                    href="#"
                    role="button"
                    onClick={(e) => {
                      e.preventDefault();
                      handlePayBill(row.original);
                    }}
                    className="underline link-style"
                    aria-label={t("bills.pay.anchor.pay")}
                  >
                    {t("bills.pay.label")}
                  </a>
                  );
                } else {
                  return <p>{t("bills.pay.label")}</p>;
                }
              } else {
                return <p>{row.original.isPaid ? t("bills.status.paid") : t("bills.pay.label")}</p>;
              }
            } else {
              return <p>{t("bills.status.paid")}</p>;
            }
          }
        },
      },
      {
        Header: t("bills.headers.amount"),
        accessor: "amount",
        id: 5,
        Cell: ({row}) => {
          return convertToPrice(row.original.amount);
        },
      },
      {
        Header: t("bills.headers.residualAmount"),
        accessor: "residualAmount",
        id: 6,
        Cell: ({row}) => {
          if (row.original.residualAmount) {
            if (checkConractStatus(current.state)) {
              return <p>{convertToPrice(row.original.residualAmount)}</p>;
            } else {
              return <p>{"-"}</p>;
            }
          } else {
            return <p>{"-"}</p>;
          }
        },
      },
      {
        Header: t("bills.headers.deferredPayment"),
        accessor: "deferredPayment",
        id: 7,
        Cell: ({row}) => {
          return row.original.deferredPayment === "N"
            ? t("bills.utils.nd")
            : t("bills.utils.yes");
        },
      },
    ],
    // eslint-disable-next-line
    [t, filters, selectedRows, current]
  );

  const renderInfoModal = () => {
    return (
      <Modal
        description= {
          genericError ? (
            genericError
          ) : (
            <> {t("download.aggregate.bills.error")} <br/>
            {t("download.aggregate.bills.error.two.years")} </>
          )
        }
        linkTitle={t("calendar.select.date")}
        type={"button"}
        onFirstClick={() => setInfoModal({active: false})}
        show={true}
        onClose={() => setInfoModal({active: false})}
      />
    );
  };

  const handleGenericError = () => {
    let error = isObject(genericError)
      ? genericError[Object.keys(genericError)[0]]
      : genericError;
    let formatedError = error.includes("_")
      ? t(`associate-contact.${error}`)
      : t(`${error}`);
    return (
      <div className={"row"}>
        <div className={"container"}>
          <div className="col-sm-12 mt-5">
            <div className={"generic-error d-flex justify-content-start"} role="alert" id="bills-table-error-message">
              <i
                className="gc-icon-functional-attention-1-col"
                aria-hidden="true"
              ></i>
              <p>{formatedError}</p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const downloaderClass = width > 768 ? "container" : "";

  const billsToShow = isCondominiumAdminOrMunicipalUser ? adminMunicipalBillsToShow : (filterMode ? filteredContracts : bills);

  return (
    <div className="BillsPage" data-testid="BillsPage">
      <Hero
        helpText={t("contract.visualization.modal.text")}
        backTo={"/"}
        backToText={t("common.back.home")}
        title={t("bills.page.title")}
        description={t("bills.page.description")}
      />
      <PaymentReceiptModal
        trackIdPayment={trackIdPayment}
        contractId={contractId}
      />
      {/*<div className={paymentClass}>*/}
      {/*  <SuccessModal*/}
      {/*    isOpen={flowFinished}*/}
      {/*    onClose={() => setFlowFinished(false)}*/}
      {/*    desc={*/}
      {/*      <div>*/}
      {/*        {responseStatus ? (*/}
      {/*          <>*/}
      {/*            <p>{t("bills.pay.bills.success")}</p>*/}
      {/*            <p>{t("bills.pay.bills.successBills")}</p>*/}
      {/*            <div className="bills-paid">*/}
      {/*              {paidBills.map(({invoiceNumber, amount}) => {*/}
      {/*                return (*/}
      {/*                  <div key={amount} className="bill">*/}
      {/*                    <p>{current && current.name}</p>*/}
      {/*                    <p>*/}
      {/*                      {t("common.billNumber")} {invoiceNumber}*/}
      {/*                    </p>*/}
      {/*                    <p>*/}
      {/*                      {t("bills.paiedBills")}: {amount}&euro;*/}
      {/*                    </p>*/}
      {/*                  </div>*/}
      {/*                );*/}
      {/*              })}*/}
      {/*            </div>*/}
      {/*          </>*/}
      {/*        ) : (*/}
      {/*          <div className="payment-fail">*/}
      {/*            <i*/}
      {/*              className="gc-icon-functional-close-circle-2-col"*/}
      {/*              aria-hidden="true"*/}
      {/*            >*/}
      {/*              <span className="path1"></span>*/}
      {/*              <span className="path2"></span>*/}
      {/*            </i>*/}
      {/*            <p>{t("bills.pay.bills.paymentFail")}</p>*/}
      {/*            <button*/}
      {/*              onClick={() => setFlowFinished(false)}*/}
      {/*              className="btn btn-primary"*/}
      {/*            >*/}
      {/*              {t("bills.pay.retry")}*/}
      {/*            </button>*/}
      {/*          </div>*/}
      {/*        )}*/}
      {/*      </div>*/}
      {/*    }*/}
      {/*    to={"/"}*/}
      {/*    linkTitle={t("common.goToDashboard")}*/}
      {/*  />*/}
      {/*</div>*/}

      <Modal
        show={showPopup}
        onClose={() => setShowPopup(false)}
        description={showPopupOnlineBill ? t("visualization.modal.text.online.bills") : null}
        type={"link"}
        styleType={"primary"}
        to={showPopupOnlineBill ? "/online-bills" : null}
        linkTitle={showPopupOnlineBill ? t("visualization.modal.text.online.bills.button") : null}
        descriptionSection2={showPopupBank ? t("visualization.modal.text.bank.domiciliation") : null}
        typeSection2={"link"}
        styleTypeSection2={"primary"}
        toSection2={showPopupBank ? "/domiciliazione-bancaria" : null}
        linkTitleSection2={showPopupBank ? t("visualization.modal.text.bank.domiciliation.button") : null}
      />

      <FiltersBox
        onStartSelected={setStartDate}
        onEndSelected={setEndDate}
        config={filterConfiguration}
        onChange={onFiltersChanged}
        onReset={onFiltersReset}
        data={bills}
        fromBillsPageAndCondominiumAdminOrMunicipalUser={isCondominiumAdminOrMunicipalUser}
        onDataFiltered={setFilteredContracts}
        showBackendFilteredData={setBackendFilteredAdminMunicipalBills}
        filter={(contracts, filters) => {
          genericError && setGenericError(null);
          if (Object.keys(filters).length === 0) {
            return contracts;
          }

          return contracts
            .filter((contract) => {
              const itemDate = new Date(contract.issueDate);
              const startDate = new Date(filters.dateStart);
              const endDate = new Date(filters.dateEnd);
              // eslint-disable-next-line no-mixed-operators
              if (filters.dateStart && filters.dateEnd) {
                console.log("entered startdate and enddate");
                return itemDate >= startDate && itemDate <= endDate;
              } else return contract;
            })
            .filter((contract) => {
              if (filters.documentType) {
                if (filters.documentType === "ALL") {
                  return contract;
                } else {
                  return (
                    contract.documentType.toLowerCase() ===
                    filters.documentType.toLowerCase()
                  );
                }
              } else return contract;
            })
            .filter((contract) => {
              if (filters.search_key) {
                return (
                  contract.invoiceNumber.toLowerCase() ===
                  filters.search_key.toLowerCase()
                );
              } else return contract;
            });
        }}
      />
      {role === UserRoleEnum.MUNICIPAL_USER || role === UserRoleEnum.CONDOMINIUM_ADMIN ? (
        <div className="container">
        <button
          type="button"
          className="container-data paragraph-main-fs8"
          onClick={() =>
            role === UserRoleEnum.CONDOMINIUM_ADMIN
              ? handleCondominiumAdminInvoicesDownload()
              : handleMunicilapDownload()
          }
          aria-label={t("download.aggregate.bills")}
        >
            {t("download.aggregate.bills")}
          <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M15.53 15.0329C15.6662 15.0329 15.7786 15.0819 15.8672 15.18C15.9557 15.2781 16 15.3903 16 15.5164C16 15.6566 15.9557 15.7722 15.8672 15.8633C15.7786 15.9544 15.6662 16 15.53 16H0.469987C0.333759 16 0.221371 15.9544 0.132822 15.8633C0.0442742 15.7722 0 15.6566 0 15.5164C0 15.3903 0.0442742 15.2781 0.132822 15.18C0.221371 15.0819 0.333759 15.0329 0.469987 15.0329H15.53ZM8.01022 0C8.13282 0 8.24181 0.0490583 8.33716 0.147175C8.43252 0.245291 8.4802 0.357424 8.4802 0.483574V11.9212L12.7305 7.54796C12.8123 7.44985 12.9178 7.40079 13.0473 7.40079C13.1767 7.40079 13.2891 7.44985 13.3844 7.54796C13.4798 7.63206 13.5275 7.74069 13.5275 7.87385C13.5275 8.00701 13.4798 8.12265 13.3844 8.22076L8.33716 13.435C8.2963 13.463 8.25883 13.4875 8.22478 13.5085C8.19072 13.5296 8.15326 13.5471 8.11239 13.5611H7.96935H7.88761C7.84674 13.5471 7.80928 13.5296 7.77522 13.5085C7.74117 13.4875 7.7037 13.463 7.66284 13.435L2.61558 8.22076C2.52022 8.12265 2.47254 8.00701 2.47254 7.87385C2.47254 7.74069 2.52022 7.63206 2.61558 7.54796C2.71094 7.44985 2.82333 7.40079 2.95275 7.40079C3.08216 7.40079 3.19455 7.44985 3.28991 7.54796L7.5198 11.9212V0.483574C7.5198 0.357424 7.56748 0.245291 7.66284 0.147175C7.75819 0.0490583 7.87399 0 8.01022 0Z" fill="black"></path></svg>
        </button>
        </div>
      ) : null}
      <div className={isCondominiumAdminOrMunicipalUser ? "container contracts-container-margin-top admin-municipal-table" : "container contracts-container-margin-top"}>
        {billsToShow.length > 0 ? (
          <>
            {/* <div className="row">
                  <div className="col-sm-12">
                    <h4 className="title">{t('bills.title')}</h4>
                  </div>
                </div> */}
            <DataTable
              // setClickedRow={setClickedRow}
              // singleCheckbox={clickedRowIndex}
              dtTable={[]}
              columns={isCondominiumAdminOrMunicipalUser ? columnsAdminOrMunicipal : columns}
              columnOrder={orderColumns}
              data={billsToShow}
              isDownloaded={downloaded}
              setDownloaded={setDownloaded}
              selectedRowsIds={handleRowSelect}
              isBackendPaginationActive={isCondominiumAdminOrMunicipalUser}
              goNextPage={nextPageCondominiumAdminOrMunicipal}
              goPrevPage={prevPageCondominiumAdminOrMunicipal}
              activePage={currentPage}
              totPages={totalPages}
            />
          </>
        ) : (
          <NoResult text={t("bills.result.no-result")}/>
        )}
        {genericError && handleGenericError()}
      </div>
      <div className={''}>
        {selectedRows && selectedRows.length ? (
          <ActionPanel
            onClick={handleDownload}
            actions={[
              {
                label:
                  getSelectedIds().length > 1
                    ? t("bills.actions.download.multiple")
                    : t("bills.actions.download"),
                icon: (
                  <i
                    className="gc-icon-functional-download-1-col"
                    aria-hidden="true"
                  ></i>
                ),
                link: "",
              },
            ]}
            selectedRows={getSelectedIds()}
          />
        ) : null}
      </div>
      {infoModal.active && renderInfoModal()}
    </div>
  );
};

export default BillsPage;
